import { useAppDispatch, useAppSelector } from '@/app'
import { CalendarProvider } from '@/features/calendar'
import { DateController } from '@/features/calendar/controllers'
import {
  selectors as coreSelectors,
  GlobalLoadingIndicator,
} from '@/features/core'
import { ServiceVisitEditorDialog } from '@/incubator/ServiceVisitEditor/ServiceVisitEditor'
import { useAuthentication } from '@alexandrainst/plana-react-api'
import { Box, Grid } from '@mui/material'
import { useEffect } from 'react'
import { ZoomController } from '../calendar/controllers/ZoomController'
import { EmployeeCalendar } from './EmployeeCalendar'
import { actions, selectors } from './personalPlanSlice'

export const PersonalPlanMainView = () => {
  const {
    calendar: {
      date,
      selectedVisit,
      visitEditorOpen,
      scale,
      gutterInterval,
      legacyGrouping,
    },
    state: { employeeId },
  } = useAppSelector(selectors.selectPersonalPlan)
  const debug = useAppSelector(coreSelectors.selectDebug)
  const dispatch = useAppDispatch()
  const {
    state: { externalSystemId: me },
  } = useAuthentication()
  useEffect(() => {
    dispatch(actions.setEmployee(me))
  }, [dispatch, me])
  const handleCloseDialog = () => dispatch(actions.closeVisitEditor())

  return (
    <CalendarProvider
      calendarSelector={selectors.selectCalendar}
      calendarActions={actions}
    >
      <Grid
        container
        direction="row"
        justifyContent="flex-start"
        alignItems="center"
        spacing={0}
        sx={{ background: '#1c78d3' }}
      >
        <ServiceVisitEditorDialog
          open={visitEditorOpen}
          visitId={selectedVisit}
          onClose={handleCloseDialog}
          debug={debug}
        />
        <Grid size={{ xs: 'auto', md: 'auto' }}></Grid>
        <Grid size={{ xs: 8, md: 10 }}>
          <DateController />
        </Grid>
        <Grid size="grow">
          <Box pr={2} sx={{ textAlign: 'right' }}>
            <GlobalLoadingIndicator />
          </Box>
        </Grid>
        <Grid size={{ md: 12, xs: 12 }} sx={{ width: '100%' }}>
          <ZoomController />
          <EmployeeCalendar
            id={employeeId ?? ''}
            date={date}
            scale={scale}
            gutterInterval={gutterInterval}
            legacyGrouping={legacyGrouping}
          />
        </Grid>
      </Grid>
    </CalendarProvider>
  )
}
